<template>
    <CodiceFeanorView tool-module="hmac" />
</template>

<script setup>
import CodiceFeanorView from "../CodiceFeanorView.vue";
</script>
